import { Icon, ItemWithLabel, SelectField } from '../../../../../../components';
import { EnvVariables, VariableName } from '../store/envVariables';
import { RuleOs } from '../store/Rule';
import classes from './VariableList.module.scss';

export default function VariableList({
  onChange,
  os,
}: {
  onChange: (variable: VariableName) => void;
  os: RuleOs[];
}) {
  const isDarwin = os.includes('darwin');
  const isLinux = os.includes('linux');
  const isWin32 = os.includes('win32');

  const options = EnvVariables.filter((variable) => {
    return (
      (isWin32 && variable.example_win32) ||
      (isDarwin && variable.example_darwin) ||
      (isLinux && variable.example_linux)
    );
  })
    .toSorted((a, b) => a.name.localeCompare(b.name))
    .map<ItemWithLabel>((variable) => ({
      value: variable.name,
      label: (
        <div>
          <div>{variable.name}</div>
          {isWin32 && variable.example_win32 && (
            <div className={classes.example}>
              <Icon icon="windows" />
              <span>{variable.example_win32}</span>
            </div>
          )}
          {isDarwin && variable.example_darwin && (
            <div className={classes.example}>
              <Icon icon="apple" />
              <span>{variable.example_darwin}</span>
            </div>
          )}
          {isLinux && variable.example_linux && (
            <div className={classes.example}>
              <Icon icon="linux" />
              <span>{variable.example_linux}</span>
            </div>
          )}
        </div>
      ),
    }));

  return (
    <SelectField
      defaultValue=""
      displayEmpty
      label="Variables"
      onChange={(e) => onChange(e.target.value)}
      options={options}
      renderValue={() => 'Show…'}
      sx={{ minWidth: 14, width: 'auto' }}
    />
  );
}
